module.exports = __webpack_public_path__ + "img/sergio1.ace18d33.jpg";